import iconFieldworkerBike from "~/assets/images/icons/icon_fieldworker_bike.svg";
import iconFieldworkerCar from "~/assets/images/icons/icon_fieldworker_car.svg";
import iconFieldworkerCarMyWheels from "~/assets/images/icons/icon_fieldworker_mywheels.svg";
import iconFieldworkerPickUp from "~/assets/images/icons/icon_fieldworker_pick_up.svg";

export const ICON_FIELDWORKER_VARIANTS = {
    bike: iconFieldworkerBike,
    myWheels: iconFieldworkerCarMyWheels,
    privateCar: iconFieldworkerCar,
    pickup: iconFieldworkerPickUp,
} as const;

export type IconFieldworkerVariant = keyof typeof ICON_FIELDWORKER_VARIANTS;
